var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/display-name */
import React from 'react';
// import RenderIfVisible from 'react-render-if-visible';
import { Virtuoso } from 'react-virtuoso';
import clsx from 'clsx';
var OuterElementContext = React.createContext({});
var OuterElementType = React.forwardRef(function (props, ref) {
    var styleProp = props.style, restProps = __rest(props, ["style"]);
    var _a = React.useContext(OuterElementContext), height = _a.height, restOuterProps = __rest(_a, ["height"]);
    var style = __assign(__assign({}, styleProp), { height: height });
    return _jsx("div", __assign({ style: style, ref: ref }, restProps, restOuterProps));
});
OuterElementType.displayName = 'OuterElementType';
export var VirtualizedList = React.forwardRef(function (props, ref) {
    // props
    var children = props.children, className = props.className, classes = props.classes, _a = props.enabled, enabled = _a === void 0 ? true : _a, style = props.style, virtuosoRef = props.virtuosoRef;
    // local variables
    var childrenArr = React.Children.toArray(children);
    // styles
    var rootClassName = clsx(classes === null || classes === void 0 ? void 0 : classes.listWrapper, className);
    // memos
    if (!enabled) {
        return (_jsx("div", __assign({ className: rootClassName, ref: ref, style: style }, { children: children })));
    }
    // :chefskiss:
    // https://virtuoso.dev/
    return (_jsx(Virtuoso, { className: rootClassName, itemContent: function (i) { return childrenArr[i]; }, ref: virtuosoRef, scrollerRef: function (r) {
            if (!ref)
                return;
            // we don't support setting the whole window as a ref
            if (r instanceof Window)
                return;
            var goodRef = r;
            if (typeof ref === 'function')
                return ref(goodRef);
            ref.current = goodRef;
        }, style: style, totalCount: React.Children.count(children) }));
});
VirtualizedList.displayName = 'VirtualizedList';
